<template>
  <v-virtual-scroll
    :items="items"
    height="120"
    item-height="60"
  >
    <v-timeline
      dense
      align-top
    >
      <timeline-item-base
        v-for="(item, indice) in items"
        :key="indice"
        :item="item"
        :indice="indice"
      />
    </v-timeline>
  </v-virtual-scroll>
</template>

<script>
import TimelineItemBase from './TimelineItemBase.vue'

export default {
  components: {
    TimelineItemBase,
  },

  props: {
    items: {
      type: Array,
      required: true,
    },
  },
}
</script>
